import React from 'react';
import Header from '../Header';
import { Box } from '@mui/material';
import SwitchPortsTable from '../tables/distro/SwitchPortsTable';
import AccessSwitchTable from '../tables/access-switch/AccessSwitchTable';
import { useParams } from 'react-router-dom';
import { DistroNameDataType } from '../../types/buildingTypes';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import BrokenLinkPage from './BrokenLinkPage';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useRequiredSearchParams } from '../../hooks/useRequiredSearchParams';
import DynamicBreadcrumbs from '../breadcrumbs/DynamicBreadcrumbs';
import pageStyles from './pageStyles';
import { useUserContext } from '../../context/userConext';

function DistroDevicesPage() {
  const { distro } = useParams<DistroNameDataType>();
  const { params, isValid } = useRequiredSearchParams(['region', 'building', 'vendor', 'site']);
  const { user_permissions } = useUserContext();

  if (!isValid || !distro) return <BrokenLinkPage />;

  const canPerformPortFlip = user_permissions.port_flip_mac_mini_action_permission;
  const canPerformPortBounce = user_permissions.port_bounce_mac_mini_action_permission;
  const canUseAccessSwitchTable = canPerformPortFlip && canPerformPortBounce;

  return (
    <>
      <Header />
      <Box sx={{ margin: 'auto', width: '80%' }}>
        <Box sx={pageStyles.dynamicBreadcrumbs}>
          <DynamicBreadcrumbs />
        </Box>
        <Typography sx={pageStyles.label} component="h1" variant="h4" align="center">
          <Tooltip title="ARP/DHCP table is not available for the selected distro!">
            <InfoOutlinedIcon fontSize="medium" color="warning" />
          </Tooltip>
          Distro manager - IP: {distro}, Region: {params.region}
        </Typography>
        {canUseAccessSwitchTable ? (
          <AccessSwitchTable
            device="distro"
            deviceIP={distro}
            selectedRegion={params.region}
            selectedBuilding={params.building}
            selectedVendor={params.vendor}
            selectedSite={params.site}
            unlimitedPortBounce={false}
            unlimitedPortFlip={false}
          />
        ) : (
          <SwitchPortsTable
            device="distro"
            deviceIP={distro}
            selectedRegion={params.region}
            selectedBuilding={params.building}
            selectedVendor={params.vendor}
            selectedSite={params.site}
          />
        )}
      </Box>
    </>
  );
}

export default DistroDevicesPage;
